import { Capacitor, registerPlugin } from '@capacitor/core'

export interface IPdfPrinterPlugin {
  /**
   * Hands a base64-encoded PDF to Android's PrintManager. Resolves once the system
   * print dialog has been handed the document — not once paper comes out, and not
   * once the seller confirms; Android owns the job from that point on.
   */
  print(options: { base64: string, jobName: string }): Promise<void>
}

const PLUGIN_NAME = 'PdfPrinter'

const PdfPrinter = registerPlugin<IPdfPrinterPlugin>(PLUGIN_NAME)

/**
 * The native half of this feature ships in the APK, but the JS half ships over OTA —
 * so a bundle that knows about PDF printing can land on an older APK that has no
 * PdfPrinterPlugin registered. Calling through would reject with Capacitor's generic
 * "not implemented" error; callers use this to give the seller an actionable message
 * (update the app, or switch the format back) instead.
 */
export const isNativePdfPrintingAvailable = (): boolean =>
  Capacitor.isNativePlatform() && Capacitor.isPluginAvailable(PLUGIN_NAME)

export const printPdfNatively = (base64: string, jobName: string): Promise<void> =>
  PdfPrinter.print({ base64, jobName })

export default PdfPrinter
